<template>
  <figure v-lazyload class="lazy-image-container">
    <ImageSpinner class="image-spinner" />
    <img @click="openImage" class="lazy-image" v-bind:data-url="source" alt="random image" tappable />
  </figure>
</template>

<script>
import LazyLoadDirective from "./../directives/LazyLoadDirective";
import ImageSpinner from "./ImageSpinner";
import ImageModal from "./../components/ImageModal";

export default {
  name: "lazy-image",
  components: {
    ImageSpinner
  },
  props: {
    source: {
      type: String,
      required: true
    }
  },
  directives: {
    lazyload: LazyLoadDirective
  },
  methods: {
    openImage(event) {
      const image = event.target.src;

      return this.$ionic.modalController
        .create({
          component: ImageModal,
          componentProps: {
            data: {
              image: image
            },
            parent: this
          }
        })
        .then(modal => modal.present());
    }
  }
};
</script>

<style scoped>
.lazy-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
}

.lazy-image-container.loaded .lazy-image {
  visibility: visible;
  opacity: 1;
  border: 0;
}

.lazy-image-container.loaded .image-spinner {
  display: none;
  width: 100%;
}

.lazy-image {
  width: 100%;
  border-radius: 4px;
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
}
</style>